import Api from "@/lib/Api";

export default {
    namespaced: true,
    state: {
        items: [],
        meta: { page: 1, limit: 20, total_items: 0, total_pages: 0 },
        requestId: 0,

        // occupation area fields
        occupationCategories: [
            { text: "Cirurgia", value: "Cirurgia" },
            { text: "Procedimento", value: "Procedimento" },
            { text: "Enfermidade", value: "Enfermidade" },
            { text: "Área de atuação (Ex: Nutrologia)", value: "Área de atuação" },
        ],
        occupationBaseFields: ['category', 'name', 'introduction', 'howTheAttendanceIsDone'],
        occupationCategoriesFields: {
            'Cirurgia': ['surgeryWhenIsRecommended', 'surgeryInterventionTypes'],
            'Procedimento': ['procedureRecommendations', 'procedureResults'],
            'Enfermidade': ['diseaseSymptoms', 'diseaseDiagnosis', 'diseaseTreatment'],
            'Área de atuação': ['areaWhenLookFor', 'areaAdvantages']
        }
    },
    mutations: {
        setItems(state, payload) {
            state.items = payload
        },
        setMeta(state, payload) {
            state.meta = payload
        },
        nextRequest(state) {
            state.requestId++
        }
    },
    actions: {
        async load({ commit, state }, payload = {}) {
            commit('nextRequest')
            const requestId = state.requestId
            const response = await Api.getFormResponses(payload);

            if (requestId !== state.requestId) return null
            if (response.error) return response

            commit('setItems', response.message)
            commit('setMeta', response.meta)
            return response
        }
    }
}
